import { useHistory } from 'react-router-dom';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Button from '../../components/Button';
import useMessageService from '../../services/i18n/useMessageService';
import { UnauthenticatedPaths } from '../../constants/Paths';
import getTargetAttribute from '../../services/getTargetAttribute';

const PasswordResetConfirmation = ({ email }) => {
    const history = useHistory();
    const [
        [
            confirmationSetDescription = 'A confirmation has been sent to {0}. Check your email for a password reset link.',
            buttonLabel = 'Back to Login',
        ],
    ] = useMessageService([
        'forgot_password.confirmation_sent_description',
        'general.back_to_login',
    ]);

    const [firstHalf, secondHalf] = confirmationSetDescription?.split('{0}') ?? [];
    const confirmationDescriptionLabel = (
        <span
            css={css`
                text-align: center;
            `}
            data-target={getTargetAttribute('forgot-password-confirmation-description')}
        >
            {firstHalf}
            <strong>{email}</strong>
            {secondHalf}
        </span>
    );

    return (
        <>
            <div
                css={css`
                    margin-bottom: 3.33rem;
                `}
            >
                {confirmationDescriptionLabel}
            </div>
            <Button
                type="button"
                onClick={() => {
                    history.push(UnauthenticatedPaths.LOGIN);
                }}
                data-target={getTargetAttribute('login-page-button')}
            >
                {buttonLabel}
            </Button>
        </>
    );
};

PasswordResetConfirmation.propTypes = {
    email: PropTypes.string.isRequired,
};

export default PasswordResetConfirmation;
